/**
 * Use this in a default case in a switch to ensure you've explicitly handled all cases
 * Because if you handle all cases exhaustively, you should never reach the default.
 * Then you can call this there
 *
 * @link https://www.youtube.com/watch?v=93RA21QfqIo
 * */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    assertUnreachable: function() {
        return assertUnreachable;
    },
    assertUnreachableNoThrow: function() {
        return assertUnreachableNoThrow;
    }
});
function assertUnreachable(x, error) {
    if (error instanceof Error) {
        throw Error;
    }
    const message = error != null ? error : 'This should not be reachable';
    throw new Error(message);
}
function assertUnreachableNoThrow(x) {
/* noop */ }

//# sourceMappingURL=switch.js.map